import validator from 'validator';

export const maskEmail = (email: string | undefined) => {
  if (!email) {
    return 'Guest';
  }

  const name = email.split('@')[0];

  if (!name) {
    return 'Guest';
  }

  const len = name.length;

  // 마스킹할 문자 수 계산 (이름 길이의 1/3, 최대 3자)
  const len2 = Math.min(Math.round(len / 3), 3);

  // 이름의 앞부분(최대 4자)과 마스킹 문자('*')를 합침
  return name.slice(0, Math.min(len - len2, 4)) + '*'.repeat(len2);
};

export const isUrl = (val: string) => {
  validator.isURL(val, {
    require_protocol: true,
    allow_underscores: true,
    require_tld: false, // localhost 등 허용 시 false
  });

  const reg =
    /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
  return reg.test(val);
};
